import "./style.css";
import { BsFillHouseDoorFill } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import CarrierLookup from "../../icons/CarrierLookup";
import LocalCallingGuide from "../../icons/LocalCallingGuide";
import MyBdo from "../../icons/MyBdo";
import serviceNow from "../../icons/serviceNow.png";
import TollFree from "../../icons/TollFree";
import { Tooltip } from "antd";

function SideBar() {
  return (
    <nav className="bg-bdo-text-01-charcoal flex flex-col w-[54px] items-center gap-5 z-[999] min-w-[54px]">
      <div className="h-[50px] flex justify-center items-center"></div>
      <Tooltip placement="right" title={"Numbers page"} color="#333333cc">
        <NavLink
          to={"/numbers"}
          className="h-[50px] w-full flex justify-center items-center hover:bg-[#1b191933]"
        >
          <BsFillHouseDoorFill fill="#fff" size={22} />
        </NavLink>
      </Tooltip>

      <Tooltip
        placement="right"
        title={"Local calling guide"}
        color="#333333cc"
      >
        <a
          href="https://www.localcallingguide.com/lca_prefix.php"
          target="_blank"
          rel="noreferrer"
          className="h-[50px] w-full flex justify-center items-center hover:bg-[#1b191933]"
        >
          <LocalCallingGuide />
        </a>
      </Tooltip>

      <Tooltip placement="right" title={"Carrier Look up"} color="#333333cc">
        <a
          href="https://freecarrierlookup.com/"
          target="_blank"
          rel="noreferrer"
          className="h-[50px] w-full flex justify-center items-center hover:bg-[#1b191933]"
        >
          <CarrierLookup />
        </a>
      </Tooltip>

      <Tooltip placement="right" title={"Toll Free Look up"} color="#333333cc">
        <a
          href="https://www.800forall.com/SearchWhoOwns.aspx"
          target="_blank"
          rel="noreferrer"
          className="h-[50px] w-full flex justify-center items-center hover:bg-[#1b191933]"
        >
          <TollFree />
        </a>
      </Tooltip>

      <aside className="flex flex-col gap-10 mt-auto mb-20 w-full">
        <Tooltip
          placement="right"
          title={
            <span>
              <i>my</i> BDO
            </span>
          }
          color="#333333cc"
        >
          <a
            href="https://bdocanada.sharepoint.com/sites/MyBDO/SitePages/Home.aspx"
            target="_blank"
            rel="noreferrer"
            className="h-[50px] w-full flex justify-center items-center hover:bg-[#1b191933]"
          >
            <MyBdo />
          </a>
        </Tooltip>
        <div className="flex justify-center items-center w-full">
          <Tooltip placement="right" title={"AssistMe"} color="#333333cc">
            <a
              href="https://bdocanprod.service-now.com/it"
              target="_blank"
              rel="noreferrer"
              className="h-[50px] w-full flex justify-center items-center hover:bg-[#1b191933]"
            >
              <img src={serviceNow} alt="" width={35} />
            </a>
          </Tooltip>
        </div>
      </aside>
    </nav>
  );
}

export default SideBar;
